import { render, staticRenderFns } from "./Pos_supplier_add.vue?vue&type=template&id=2e854113&"
import script from "./Pos_supplier_add.vue?vue&type=script&lang=js&"
export * from "./Pos_supplier_add.vue?vue&type=script&lang=js&"
import style0 from "./Pos_supplier_add.vue?vue&type=style&index=0&id=2e854113&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports